import compose from 'recompose/compose';

import categoriesProvider from '../categories/hoc/categoriesProvider';
import brandsProvider from '../brands/hoc/brandsProvider';

const categoriesAndBrandsProvider = compose(
  categoriesProvider,
  brandsProvider,
);

export default categoriesAndBrandsProvider;
